import React from 'react'

interface Props {
    children?: React.ReactNode
}
const HorizontalCardLeftBottom: React.FC<Props> = props => {
    return <>{props.children}</>
}

export default HorizontalCardLeftBottom
